import $ from 'jquery';
import Component from '../models/Component';

export default class tabProduct extends Component {
    constructor(element, context) {
        super(element, context);

        $(() => {

          const self = this;
          
          this.element.on('click', function() {
            const dataId = self.element.data('id');
            const targetDiv = $(`.${dataId}`);
            $('.post-tab').hide();
            
            if (targetDiv.is(':visible')) {
              targetDiv.fadeOut();
            } else {
              targetDiv.fadeIn();
            }
          });
        });
    }
}
